var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoLibrary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.54109 7.51758H22.4594C23.58 7.51758 24.0002 8.54482 23.9535 9.15182L22.8329 21.2452C22.6928 22.7861 21.4321 23.9534 19.8913 23.9534H4.10919C2.56833 23.9534 1.30763 22.7861 1.16755 21.2452L0.0469303 9.15182C0.000237722 8.54482 0.420471 7.51758 1.54109 7.51758ZM3.64226 16.2958C3.87572 19.5643 7.61113 22.1324 12.0002 22.1324C16.3893 22.1324 20.1248 19.5643 20.3582 16.2958C20.5917 12.7938 16.8563 9.80552 12.0002 9.80552C7.14421 9.80552 3.4088 12.7938 3.64226 16.2958Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3387 0.046875C21.9457 0.046875 22.4593 0.560494 22.4593 1.1675V2.28812H1.54103V1.1675C1.54103 0.560494 2.05465 0.046875 2.66165 0.046875H21.3387ZM1.91457 3.78228H22.0858C22.6928 3.78228 23.2064 4.2959 23.2064 4.90291V6.02353H0.793945V4.90291C0.793945 4.2959 1.30756 3.78228 1.91457 3.78228ZM12.0002 9.80563C7.14414 9.80563 3.40873 12.794 3.64219 16.2959C3.87566 19.5644 7.61107 22.1325 12.0002 22.1325C16.3893 22.1325 20.1247 19.5644 20.3581 16.2959C20.5916 12.794 16.8562 9.80563 12.0002 9.80563ZM10.5994 16.2959C10.5994 16.8562 11.2531 17.3231 12.0002 17.3231C12.7473 17.3231 13.4009 16.8562 13.4009 16.2959C13.4009 15.7356 12.7939 15.2687 12.0002 15.2687C11.2064 15.2687 10.5994 15.7356 10.5994 16.2959Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoLibrary);
export default __webpack_public_path__ + "static/media/video_library.8b338e9d4f57f5d6845946cc3f666960.svg";
export { ForwardRef as ReactComponent };